import { HTTP } from "@/api";

const merge = (t, s) => {
  const o = Object,
    a = o.assign;
  for (const k of o.keys(s)) s[k] instanceof o && a(s[k], merge(t[k], s[k]));
  return a(t || {}, s), t;
};

export default {
  fetchMatches({ state, commit }, matches) {
    matches = matches.map(m => {
      let match = state.live.matches.find(item => item._id === m._id);
      if (m.home) m.home.activeGoal = match ? match.home.activeGoal : false;
      if (m.away) m.away.activeGoal = match ? match.away.activeGoal : false;
      return m;
    });

    commit("matches", matches);
    commit("filterLoading", false);
  },
  fetchActive({ state, commit }, matches) {
    matches = matches.map(m => {
      let match = state.live.active.find(item => item._id === m._id);
      if (m.home) m.home.activeGoal = match ? match.home.activeGoal : false;
      if (m.away) m.away.activeGoal = match ? match.away.activeGoal : false;
      return m;
    });

    commit("activeLiveCount", matches);
  },
  updateMatches({ state, commit, dispatch }, { channel, result, type }) {
    if (!result.length) return;
    const data = {
      ...((type === "matches" || !type) && {
        matches: state[channel].matches.slice()
      }),
      ...((type === "active" || !type) && {
        active: state[channel].active.slice()
      })
    };
    result.forEach(({ changes, _id }) => {
      Object.keys(data).forEach(type => {
        const list = data[type];
        const index = list.findIndex(m => m._id === _id);
        const remove =
          (index >= 0 &&
            (changes.filtered &&
              changes.filtered[channel] &&
              changes.filtered[channel] === false)) ||
          (changes.status &&
            changes.status[channel] &&
            changes.status[channel] === false);
        const add =
          index < 0 &&
          (changes.filtered &&
            changes.filtered[channel] &&
            changes.filtered[channel] === true) &&
          (changes.status &&
            changes.status[channel] &&
            changes.status[channel] === true);
        if (remove && type === "matches") {
          list.splice(index, 1);
          dispatch("fetchMatches", list);
        } else if (add) {
          if (changes.home) changes.home.activeGoal = false;
          if (changes.away) changes.away.activeGoal = false;
          list.push(changes);
          dispatch(type === "matches" ? "fetchMatches" : "fetchActive", list);
        } else {
          if (index < 0) return;
          let match = list[index];
          ["home", "away"].forEach(key => {
            if (
              changes[key] &&
              changes[key].statistic &&
              changes[key].statistic.score
            ) {
              if (match[key].statistic.score !== changes[key].statistic.score) {
                changes[key].activeGoal = true;
                setTimeout(() => {
                  dispatch("updateMatches", {
                    channel,
                    result: [
                      {
                        _id,
                        changes: {
                          [key]: {
                            activeGoal: false
                          }
                        }
                      }
                    ]
                  });
                }, 60000);
              }
            }
          });

          commit("match", { _id, match: merge(match, changes), type });
        }
      });
    });
  },
  getLiveStatistic({ commit }) {
    commit("isLoading", {
      key: "live statistic",
      status: true
    });
    return HTTP.get("/live/stat").then(res => {
      if (res.data) commit("liveStatistic", res.data);
    });
  }
};
